module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mapNodesCounter":"{0} node(s)"},"fr":{"mapNodesCounter":"{0} noeud(s)"}}')
  delete Component.options._Ctor
}
